import { createSlice } from "@reduxjs/toolkit";

const token = localStorage.getItem("userToken");
const user = localStorage.getItem("userId");
const userFirstName = localStorage.getItem("userFirstName");
const userLastName = localStorage.getItem("userLastName");
const userEmail = localStorage.getItem("userEmail");
const userMobile = localStorage.getItem("userMobile");

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user,
    userFirstName,
    userLastName,
    userEmail,
    userMobile,
    token: token,
    isFetching: false,
    error: false,
    errMsg: "",
  },
  reducers: {
    loginStart: (state, action) => {
      state.isFetching = true;
      state.error = false;
    },
    loginSuccess: (state, action) => {
      state.errMsg = "";
      state.error = false;

      state.isFetching = false;
      state.error = false;
      state.user = action.payload.user._id;
      state.userFirstName = action.payload.user?.firstname;
      state.userLastName = action.payload.user?.lastname;
      state.userEmail = action.payload.user?.email;
      state.userMobile = action.payload.user?.mobile_no;
      state.token = action.payload.token;

      localStorage.setItem("userToken", state.token);
      localStorage.setItem("userId", state.user);
      localStorage.setItem("userFirstName", state.userFirstName);
      localStorage.setItem("userLastName", state.userLastName);
      localStorage.setItem("userEmail", state.userEmail);
      localStorage.setItem("userMobile", state.userMobile);
    },
    loginFailure: (state, action) => {
      state.errMsg = action.payload;
      state.isFetching = false;
      state.error = true;
    },

    registerStart: (state, action) => {
      state.isFetching = true;
      state.error = false;
    },
    registerSuccess: (state, action) => {
      state.error = false;
      state.errMsg = "";
      state.isFetching = false;
      state.error = false;
      state.user = action.payload.user._id;
      state.userFirstName = action.payload.user?.firstname;
      state.userLastName = action.payload.user?.lastname;
      state.userEmail = action.payload.user?.email;
      state.userMobile = action.payload.user?.mobile_no;
      state.token = action.payload.token;

      localStorage.setItem("userToken", state.token);
      localStorage.setItem("userId", state.user);
      localStorage.setItem("userFirstName", state.userFirstName);
      localStorage.setItem("userLastName", state.userLastName);
      localStorage.setItem("userEmail", state.userEmail);
      localStorage.setItem("userMobile", state.userMobile);
    },
    registerFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.errMsg = action.payload;
    },

    logOut: (state, action) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("userId");
      localStorage.removeItem("userToken");
    },
  },
});

export const {
  logOut,
  loginStart,
  loginSuccess,
  loginFailure,
  registerSuccess,
  registerStart,
  registerFailure,
} = authSlice.actions;
export default authSlice.reducer;
